import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, tap } from 'rxjs';
import { MarketProfile } from '../market-profile.model';
import { FormHelper } from '../../shared/mixin/form-helper';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketProfileService } from '../market-profile.service';
import { NotificationService } from '../../shared/service/notification.service';
import { finalize } from 'rxjs/operators';
import { PRODUCT_CODES } from '../../shared/misc/regex';

@Component({
  selector: 'app-update-market-profile-form',
  templateUrl: './update-market-profile-form.component.html',
  styleUrls: ['./update-market-profile-form.component.scss']
})
export class UpdateMarketProfileFormComponent extends FormHelper() implements OnInit {

  public form!: UntypedFormGroup;
  public marketProfileId!: string;
  public marketProfileData: Observable<MarketProfile>;
  public isLoading: boolean = true;
  public isSaving: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private marketProfileService: MarketProfileService,
    private notificationService: NotificationService
  ) {
    super();
    this.marketProfileData = new Observable<MarketProfile>();
  }

  ngOnInit(): void {
    this.form = this.createForm();

    this.marketProfileId = this.route.snapshot.paramMap.get('id')!;
    this.marketProfileData = this.marketProfileService
      .find(this.marketProfileId)
      .pipe(
        finalize(() => this.isLoading = false),
        tap((next) => {
          this.initializeFormData(next);
        })
      );
  }

  public onSubmit(): void {
    if (!this.form.valid) {
      return;
    }

    this.isSaving = true;

    const payload = {
      name: this.form.value.name,
      productCodes: this.form.value.productCodes.split(','),
      isAvailableForGuest: this.form.value.isAvailableForGuest,
      isAvailableForRetail: this.form.value.isAvailableForRetail
    }

    this.marketProfileService
      .update(this.marketProfileId, payload)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.notificationService.success_ts('market_profile.updated');
          this.router.navigateByUrl('/market-profiles');
        }
      });
  }

  private createForm() {
    return this.fb.group({
      name: this.fb.control('', [
        Validators.required,
        Validators.maxLength(50)
      ]),
      productCodes: this.fb.control(null,
        [
          Validators.required,
          Validators.pattern(PRODUCT_CODES)
        ]
      ),
      isAvailableForGuest: this.fb.control(null),
      isAvailableForRetail: this.fb.control(null)
    });
  }

  private initializeFormData(response: MarketProfile)
  {
    this.form.patchValue({
      name: response.name,
      productCodes: response.productCodes?.join(','),
      isAvailableForGuest: response.isAvailableForGuest,
      isAvailableForRetail: response.isAvailableForRetail
    })
  }
}
